import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';
import './Admin.css';

const Admin: React.FC = () => {
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [excerpt, setExcerpt] = useState('');
  const [tags, setTags] = useState('');
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await getCurrentUser();
        // Mock Role Check: In a real app, you'd fetch user attributes or groups here.
        // For now, we assume any logged-in user can view, but we'll restrict publishing below.
        
        // For demonstration, let's assume the current user has role_id = 0 (Admin)
        const mockRoleId = 0; 
        
        if (mockRoleId === 0) {
            setIsAdmin(true);
        }
        
        setLoading(false);
      } catch (error) {
        console.log('User not signed in, redirecting...');
        navigate('/login');
      }
    };

    checkAuth();
  }, [navigate]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!isAdmin) {
        alert("Permission Denied: You do not have the required role (role_id=0) to publish.");
        return;
    }

    alert(`Blog "${title}" uploaded successfully! (Mock Action)`);
    // Reset form
    setTitle('');
    setContent('');
    setExcerpt('');
    setTags('');
  };

  if (loading) return <div className="admin-container">Loading...</div>;

  return (
    <div className="admin-container">
      <h1>Admin Dashboard</h1>
      <p>Upload new System Design Blogs here.</p>
      
      {!isAdmin && (
          <div className="error-message">
              Warning: You are logged in but do not have publishing privileges (role_id != 0).
          </div>
      )}

      <form className="admin-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="title">Blog Title</label>
          <input 
            type="text" 
            id="title" 
            value={title} 
            onChange={(e) => setTitle(e.target.value)} 
            required 
            placeholder="e.g., Designing a URL Shortener"
            disabled={!isAdmin}
          />
        </div>

        <div className="form-group">
          <label htmlFor="excerpt">Excerpt</label>
          <textarea 
            id="excerpt" 
            value={excerpt} 
            onChange={(e) => setExcerpt(e.target.value)} 
            required 
            placeholder="Short summary for the card view..."
            rows={3}
            disabled={!isAdmin}
          />
        </div>

        <div className="form-group">
            <label htmlFor="tags">Tags (comma separated)</label>
            <input 
                type="text" 
                id="tags" 
                value={tags} 
                onChange={(e) => setTags(e.target.value)} 
                placeholder="System Design, Scalability, Database"
                disabled={!isAdmin}
            />
        </div>

        <div className="form-group">
          <label htmlFor="content">Markdown Content</label>
          <textarea 
            id="content" 
            value={content} 
            onChange={(e) => setContent(e.target.value)} 
            required 
            placeholder="# Introduction..."
            rows={15}
            className="content-area"
            disabled={!isAdmin}
          />
        </div>

        <button type="submit" className="submit-btn" disabled={!isAdmin}>Publish Blog</button>
      </form>
    </div>
  );
};

export default Admin;

